import { PhoneContact } from './phone-contact.model';

export class Employee {
    constructor(obj: Partial<Employee>) {
        Object.assign(this, obj);
    }
   email: string;
   firstName: string;
   id: number;
   companyId: number;
   lastName: string;
   middleName: string;
   designation:string;
   password: string;
   confirmPassword?: string;
   username:string;
   phoneContact?: PhoneContact;
   roleIds: [];
   phone:string;
   phoneCode:string;
   address?: any;
}
